import { Form, message } from 'antd';
import { Modal } from 'components';
import { UserApiService } from 'features/users/api/user-api.service';
import { StyledUserModalWrapper } from 'features/users/components/modals/user-modal.styles';
import { UserFormValues } from 'features/users/components/users-filter-form';
import { useUpdateUser } from 'features/users/use-cases';
import { useGetClientsServiceList } from 'features/users/use-cases/get-management-services';
import { useUpdateUserSendEmailAccess } from 'features/users/use-cases/update-user-eamil-access';
import { useUserContext } from 'features/users/user-context';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { UserInfoFormEditItems } from './user-info-form-edit-item';
export const EditAdminUserModal = ({
  onClose,
  onSuccess,
  id,
}: {
  onClose: () => void;
  onSuccess: () => void;
  id: string;
}) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const formName = 'edit-user-form';
  const { user } = useUserContext();
  const [form] = Form.useForm<UserFormValues>();
  const { t } = useTranslation();
  const [userData, setUserData] = useState<any>('');
  const [categoryChecks, setCategoryChecks] = useState<any>({});
  const [subCategoryChecks, setSubCategoryChecks] = useState<any>({});
  const [classCategoryChecks, setClassCategoryChecks] = useState<any>({});
  const parmas = {
    CompanyId: user?.CompanyId,
    ClientId: id,
  };
  const getUsersListQueryResponse = useGetClientsServiceList(parmas, {
    retry: false, // Disable retry if the query fails
  });

  const initial = async () => {
    try {
      const apires = await UserApiService().getUserClients({
        Id: id,
        CompanyId: user?.CompanyId,
        PageIndex: 1,
        RecordPerPage: 10,
      } as any);
      setUserData(apires);
    } catch (error: any) {
      message.error(error);
    }
  };
  const handlePayloadSet = () => {
    const payload: { ServiceId: string; categoryName: string }[] = []; // Initialize payload array
    getUsersListQueryResponse?.data?.data?.rc.forEach((category: any) => {
      // Check if the main category switch is checked
      if (categoryChecks[category.Id]) {
        // Include the main category if its switch is checked
        payload.push({ ServiceId: category.Id } as any);

        category.SubCategoryList?.forEach((subCategory: any) => {
          // Include subcategory only if its switch is checked
          if (subCategoryChecks[subCategory.Id]) {
            payload.push({ ServiceId: subCategory.Id } as any);
          }

          subCategory.ClassCategoryList?.forEach((classCategory: any) => {
            // Include class category only if its switch is checked
            if (classCategoryChecks[classCategory.Id]) {
              payload.push({ ServiceId: classCategory.Id } as any);
            }
          });
        });
      } else {
        // If the main category switch is unchecked, skip it along with its subcategories and class categories
        category.SubCategoryList?.forEach((subCategory: any) => {
          if (subCategoryChecks[subCategory.Id]) {
            payload.push({ ServiceId: subCategory.Id } as any);
          }

          subCategory.ClassCategoryList?.forEach((classCategory: any) => {
            if (classCategoryChecks[classCategory.Id]) {
              payload.push({ ServiceId: classCategory.Id } as any);
            }
          });
        });
      }
    });

    // Set the payload for further processing
    return payload;
  };
  const { mutate: mutateUpdateUser, isLoading: isLoadingUpdateUser } =
    useUpdateUser();
  const { mutate: mutateUpdateUserEmail, isLoading: isLoadingUpdateUserEmail } =
    useUpdateUserSendEmailAccess();
  const handleUpdate = (formData: any) => {
    const payload1 = handlePayloadSet();
    const payload: any = {
      CompanyId: user?.CompanyId,
      UserId: id,
      RoleId: formData.RoleId,
      SendMailAccess: formData?.SendMailAccess,
      ServiceListTemp: JSON.stringify(payload1),
    };
    const payloadEmail = {
      CompanyId: user?.CompanyId,
      UserId: id,
      SendMailAccess: formData?.SendMailAccess,
    };
    if (userData?.rc?.[0]?.IsPrimary == true) {
      mutateUpdateUserEmail(payloadEmail, { onSuccess });
    } else {
      mutateUpdateUser(payload, { onSuccess });
    }
  };
  useEffect(() => {
    initial();
  }, []);
  useEffect(() => {
    form.setFieldsValue({
      Name: userData?.rc?.[0]?.Name || '',
      Email: userData?.rc?.[0]?.Email || '',
      RoleId: userData?.rc?.[0]?.RoleId || '',
      SendMailAccess: userData?.rc?.[0]?.SendMailAccess || '',
    } as any);
  }, [userData, form]);

  return (
    <StyledUserModalWrapper>
      <Modal
        open
        centered
        title={t('adminUsers.userInfo')}
        onCancel={onClose}
        getContainer={false}
        onOk={form.submit}
        okText={t('adminUsers.updateUser')}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={
          {
            form: formName,
            loading: isLoadingUpdateUser || isLoadingUpdateUserEmail,
          } as any
        }
        maskClosable={false}
      >
        <Form<UserFormValues>
          id={formName}
          name={formName}
          form={form}
          layout='vertical'
          onFinish={handleUpdate}
          onFinishFailed={() => {
            setValidateTrigger(['onChange']);
          }}
          validateTrigger={validateTrigger}
          disabled={isLoadingUpdateUser || isLoadingUpdateUserEmail}
        >
          <UserInfoFormEditItems
            getUsersListQueryResponse={getUsersListQueryResponse}
            categoryChecks={categoryChecks}
            setCategoryChecks={setCategoryChecks}
            subCategoryChecks={subCategoryChecks}
            classCategoryChecks={classCategoryChecks}
            setSubCategoryChecks={setSubCategoryChecks}
            setClassCategoryChecks={setClassCategoryChecks}
            userData={userData}
          />
        </Form>
      </Modal>
    </StyledUserModalWrapper>
  );
};
